import Vue from "vue"
import VueRouter from "vue-router"
import axios from "axios"
import InstantSearch from "vue-instantsearch"
import store from "./store/index.js"
import JsonCSV from "vue-json-csv"
import VueAnalytics from "vue-analytics"
import App from "./app.vue"
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

import { library } from "@fortawesome/fontawesome-svg-core"
import {
    faQuestionCircle,
    faEye,
    faBars,
    faCog,
    faTimes,
    faFileDownload,
    faSpinnerThird,
} from "@fortawesome/pro-regular-svg-icons"
import {
    faListUl,
    faPlus,
    faUserSecret,
    faSignOut,
    faCheck,
} from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

Vue.config.productionTip = false
const isProd = process.env.NODE_ENV === "production"

Vue.use(VueRouter)
Vue.use(InstantSearch)

// Setup toast, yummy

const options = {}
Vue.use(Toast, options)

// Setup font awesome
library.add(
    faUserSecret,
    faListUl,
    faQuestionCircle,
    faPlus,
    faSignOut,
    faFileDownload,
    faEye,
    faBars,
    faCog,
    faTimes,
    faCheck,
    faSpinnerThird
)
Vue.component("font-awesome-icon", FontAwesomeIcon)

// Download CSV
Vue.component("downloadCsv", JsonCSV)

// Get window variables
Vue.prototype.$appData = window.appData
Vue.prototype.$http = axios

// Set up the router
import { routes } from "./routes"
const router = new VueRouter({
    mode: "history",
    routes,
})

// Set up analytics

Vue.use(VueAnalytics, {
    id: "UA-147581300-3",
    router,
    debug: {
        enabled: !isProd,
        sendHitTask: isProd,
    },
    set: [
        {
            field: "userId",
            value: appData.userId,
        },
    ],
})

new Vue({
    el: "#app",
    delimiters: ["${", "}"],
    router,
    store,
    render: (h) => h(App),
})
